import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faTiktok,
  faSnapchatGhost,
  faXTwitter,
  faInstagram
} from '@fortawesome/free-brands-svg-icons';
import NewsletterForm from './NewsletterForm';

const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer className="bg-white border-t border-gray-200 mt-8 pt-8 pb-4 px-4 shadow-inner text-gray-800">
      <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-8">

        {/* Newsletter Signup */}
        <NewsletterForm />

        {/* <div className="md:col-span-1 text-center md:text-left flex flex-col items-center md:items-start gap-4">
  <h3 className="text-lg font-semibold mb-2">{t('footer.stayUpdated') || 'Stay Updated'}</h3>
  <p className="text-sm text-gray-600 mb-4">{t('footer.newsletterHint') || 'Subscribe to get price drops & deals'}</p>
  
  <form onSubmit={(e) => e.preventDefault()} className="flex flex-col md:flex-row items-center gap-2 w-full md:w-auto">
    <input
      type="email"
      placeholder={t('footer.emailPlaceholder') || 'Enter your email'}
      className="input input-bordered w-full md:w-64 text-sm mb-2 md:mb-0 mb-0 focus:outline-none focus:ring-1 focus:ring-[#FF9900] focus:border-[#FF9900]"
    />
    <button className="btn bg-primary text-white hover:bg-primary/90 text-sm w-full md:w-auto">
      {t('footer.subscribe') || 'Subscribe'}
    </button>
  </form>
</div> */}


        {/* Navigation */}
        <div className="flex flex-col items-center md:items-start gap-2 text-sm justify-center">
          <Link to="/privacy" className="hover:text-primary transition">{t('footer.privacyPolicy')}</Link>
          <Link to="/terms" className="hover:text-primary transition">{t('footer.tos')}</Link>
          <Link to="/contact" className="hover:text-primary transition">{t('footer.contactUs')}</Link>
        </div>

        {/* Logo & Socials */}
        <div className="flex flex-col items-center md:items-end space-y-4">
          <Link to="/">
            <img
              src="/logo.png"
              alt="PriceAlertz Logo"
              className="w-36 h-auto"
            />
          </Link>
          <div className="flex gap-4 text-xl text-gray-600">
            <a href="https://www.tiktok.com/@glamalertz" target="_blank" rel="noopener noreferrer" className="hover:text-black">
              <FontAwesomeIcon icon={faTiktok} />
            </a>
            <a href="https://x.com/glamalertz" target="_blank" rel="noopener noreferrer" className="hover:text-black">
              <FontAwesomeIcon icon={faXTwitter} />
            </a>
            <a href="https://www.youtube.com/@glamalertz" target="_blank" rel="noopener noreferrer" className="hover:text-pink-600">
              <FontAwesomeIcon icon={faInstagram} />
            </a>
            <a href="https://www.snapchat.com/add/glamalertz" target="_blank" rel="noopener noreferrer" className="hover:text-yellow-500">
              <FontAwesomeIcon icon={faSnapchatGhost} />
            </a>
          </div>
        </div>

      </div>

      {/* Bottom Text */}
      <div className="text-center text-xs text-gray-500 mt-6">
        &copy; {new Date().getFullYear()} {t('footer.copyright')}
      </div>
    </footer>
  );
};

export default Footer;